import PropTypes from '../../_util/vue-types'

export default {
  name: 'ColumnGroup',
  props: {
    title: PropTypes.any,
  },
  isTableColumnGroup: true,
}



// WEBPACK FOOTER //
// ./components/vc-table/src/ColumnGroup.jsx